export default __webpack_public_path__ + "ac2bb58c2960c8937b4207496d3c5622.png";